import { GETSINGLEPOLICYDETAILES_SUCCESS, GETSINGLEPOLICYDETAILES_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getSinglePolicyDetailesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETSINGLEPOLICYDETAILES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETSINGLEPOLICYDETAILES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getSinglePolicyDetailesReducer;
